import * as amplitude from '@amplitude/analytics-browser';
import { AmplitudeEventProperties } from './events';

const AMPLITUDE_API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;

export const initAmplitude = (userId?: string) => {
  if (typeof window !== 'undefined') {
    amplitude.init(AMPLITUDE_API_KEY ?? '', {
      defaultTracking: true,
      logLevel: amplitude.Types.LogLevel.Warn,
    });

    if (userId) {
      amplitude.setUserId(userId);
    }
  }
};

export const trackEvent = <T extends keyof AmplitudeEventProperties>(
  eventName: T,
  eventProperties?: AmplitudeEventProperties[T],
) => {
  if (typeof window === 'undefined') return;

  amplitude.track(eventName, {
    ...eventProperties,
    screen: window.location.href,
    userAgent: navigator.userAgent,
  });
};

// export const identifyUser = (userId: string, userProperties?: Record<string, unknown>) => {
//   if (typeof window !== 'undefined') return;

//   const indentify = new amplitude.Identify();
//   Object.entries(userProperties || {})?.forEach(([key, value]) => {
//     indentify.set(key, value as amplitude.Types.ValidPropertyType);
//   });
//   amplitude.identify(indentify);
//   amplitude.setUserId(userId);
// };
